import { useNavigate } from "react-router-dom";
import eyLogo from "../../ey_logo.svg";
import './AppBarHeader.scss';

export default function AppBarHeader() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/logout-success");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };


  let headingText = "Mobility - GTM Factory";

  return (
    <div className="header">
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          height="40px"
          width="40px"
          style={{ margin: "10px" }}
          src={eyLogo}
          alt="Logo"
        />
        <h2 className="heading">{headingText}</h2>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <a onClick={() => navigate('/')} className="logout-button" style={{ marginRight: "16px" }}>
          Avatar
        </a>
        <a onClick={handleLogout} className="logout-button" style={{ marginRight: "16px" }}>
          Logout
        </a>
      </div>
    </div>
  );
}
